export default "__VITE_ASSET__Bl5R6J5P__"